// Generate Analytics Links Report
export const GENERATE_ANALYTICS_LINKS_REPORT_REQUEST = 'GENERATE_ANALYTICS_LINKS_REPORT_REQUEST';
export const GENERATE_ANALYTICS_LINKS_REPORT_DONE = 'GENERATE_ANALYTICS_LINKS_REPORT_DONE';
export const GENERATE_ANALYTICS_LINKS_REPORT_FAILED = 'GENERATE_ANALYTICS_LINKS_REPORT_FAILED';
export const GENERATE_ANALYTICS_LINKS_REPORT_RESET = 'GENERATE_ANALYTICS_LINKS_REPORT_RESET';
